<ui-section>
  <div class="flex flex-row gap-2"> <span>Use Signal </span><p-toggle-switch [(ngModel)]="useSignal">Use Signal</p-toggle-switch></div>
</ui-section>
<ui-section>

  @if(useSignal())
  {
  <ui-block width="2x" class="outline">
    <h3>Form A</h3>
    <ui-form
      [(formValues)]="formValuesSig"
      [config]="validationsFormConfig"
    />
  </ui-block>

  <ui-block width="2x">
    <h3>Form B</h3>
    <ui-form
      [(formValues)]="formValuesSig"
      [config]="validationsFormConfig"
    />
  </ui-block>
}
@else {
  <ui-block width="2x">
    <h3>Form A</h3>
    <ui-form
      [(formValues)]="formValues"
      [config]="validationsFormConfig"
    />
  </ui-block>

  <ui-block width="2x">
    <h3>Form B</h3>
    <ui-form
      [(formValues)]="formValues"
      [config]="validationsFormConfig"
    />
  </ui-block>
}


<ui-block>

  <div class="flex flex-col gap-1">
  <h3>Non-form block</h3>

  <div><span>First Name: </span><span>{{ useSignal() ? formValuesSig().firstName : formValues.firstName }}</span></div>

  <h4>These work with signals</h4>
  <div><span>Computed First Name: </span><span>{{ computedFirstName() }}</span> </div>


  <!-- Using a signal for formValues, note that we need to hook up (ngModelChange)=updateSignalProperty() to make this work for non-ez-form inputs (which would be rare, if ever) -->
  <div *ngIf="useSignal()"><span>Input First Name: </span>
    <input [disabled]="disableInput()"
    [ngModel]="formValuesSig().firstName"
    (ngModelChange)="updateSignalProperty(formValuesSig, 'firstName', $event)"
    type="text"

    /><span><-- [disabled] is based on computed.</span>
  </div>

  <!-- Not using a signal, computed()s won't work because they depend on a signal to change and there is no signal to trigger on -->
  <div *ngIf="!useSignal()"><span>Input First Name: </span>
    <input [disabled]="disableInput()"
    [(ngModel)]="formValues.firstName"
    type="text"

    /><span><-- [disabled] is based on computed.</span>
  </div>

  <div>From effect(): {{lastUpdateMsg}}</div>

  </div>
</ui-block>

</ui-section>